(function( $ ) {
    'use strict';

    $( window ).load(function() {
        if (window.location.href.indexOf("gift-card") === -1 || window.location.href.indexOf("products") === -1 ) {
            // only run this on the correct page
            return;
        }

        if (window.location.href.indexOf("the-day-script") != -1 ) {
            window.products.setAdditionalField('#form-field-journey_id', 'journey_id');
            return;
        }
        // populate the product additional data attributes
        window.products.setAdditionalField('#form-field-acc_email_to', 'email_to');
        // window.products.setAdditionalField('#form-field-acc_email_from', 'email_from');
        window.products.setAdditionalField('#form-field-message', 'message');
        window.products.setAdditionalField('#form-field-delivery_date', 'delivery_date');

    })

})( jQuery );
